// src/core/modals/sales/TransactionModal.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Printer, Eye, Edit, Trash2 } from 'feather-icons-react/build/IconComponents';

const TransactionModal = ({ isOpen, onClose }) => {
    // Hardcoded data for each tab
    const purchaseData = [
        {
            id: 1,
            customer_name: 'Carl Evans',
            reference: 'INV/SL0101',
            date: '24 Dec 2024',
            amount: 1000,
            image: 'assets/img/users/user-27.jpg',
        },
        {
            id: 2,
            customer_name: 'Jane Doe',
            reference: 'INV/SL0102',
            date: '25 Dec 2024',
            amount: 750,
            image: 'assets/img/users/user-28.jpg',
        },
    ];

    const paymentData = [
        {
            id: 1,
            customer_name: 'John Smith',
            reference: 'PAY/001',
            date: '23 Dec 2024',
            amount: 500,
            image: 'assets/img/users/user-29.jpg',
        },
        {
            id: 2,
            customer_name: 'Sarah Johnson',
            reference: 'PAY/002',
            date: '24 Dec 2024',
            amount: 1200,
            image: 'assets/img/users/user-30.jpg',
        },
    ];

    const returnData = [
        {
            id: 1,
            customer_name: 'Mike Brown',
            reference: 'RET/001',
            date: '22 Dec 2024',
            amount: 200,
            image: 'assets/img/users/user-31.jpg',
        },
        {
            id: 2,
            customer_name: 'Emily Davis',
            reference: 'RET/002',
            date: '23 Dec 2024',
            amount: 300,
            image: 'assets/img/users/user-32.jpg',
        },
    ];

    const [searchTerm, setSearchTerm] = useState('');

    if (!isOpen) return null;

    const renderTable = (data, type) => {
        const filteredData = data.filter(
            (item) =>
                item.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.reference.toLowerCase().includes(searchTerm.toLowerCase())
        );

        return (
            <div className="card mb-0">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <div className="input-icon-start search-pos position-relative mb-2 me-3">
                        <span className="input-icon-addon">
                            <i className="ti ti-search"></i>
                        </span>
                        <input type="text" className="form-control" placeholder={`Search ${type}`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="PDF">
                                <img src="assets/img/icons/pdf.svg" alt="PDF" />
                            </a>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel">
                                <img src="assets/img/icons/excel.svg" alt="Excel" />
                            </a>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print">
                                <Printer />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table datatable border">
                            <thead className="thead-light">
                                <tr>
                                    <th className="no-sort">
                                        <label className="checkboxs">
                                            <input type="checkbox" className="select-all" />
                                            <span className="checkmarks"></span>
                                        </label>
                                    </th>
                                    <th>Customer</th>
                                    <th>Reference</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th className="no-sort">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item) => (
                                        <tr key={`${type}-${item.id}`}>
                                            <td>
                                                <label className="checkboxs">
                                                    <input type="checkbox" />
                                                    <span className="checkmarks"></span>
                                                </label>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <a href="#" className="avatar avatar-md me-2">
                                                        <img src={item.image} alt="Customer" />
                                                    </a>
                                                    <a href="#">{item.customer_name}</a>
                                                </div>
                                            </td>
                                            <td>{item.reference}</td>
                                            <td>{item.date}</td>
                                            <td>${item.amount.toFixed(2)}</td>
                                            <td className="action-table-data">
                                                <div className="edit-delete-action">
                                                    <a
                                                        className="me-2 edit-icon p-2"
                                                        href="#"
                                                        onClick={() => alert(`View transaction ${item.reference}`)}
                                                    >
                                                        <Eye />
                                                    </a>
                                                    <a
                                                        className="me-2 p-2"
                                                        href="#"
                                                        onClick={() => alert(`Edit transaction ${item.reference}`)}
                                                    >
                                                        <Edit />
                                                    </a>
                                                    <a
                                                        className="p-2"
                                                        href="#"
                                                        onClick={() => alert(`Delete transaction ${item.reference}`)}
                                                    >
                                                        <Trash2 />
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No {type} transactions found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div
            className="modal fade pos-modal show"
            id="recents"
            tabIndex="-1"
            aria-labelledby="recent-transactions"
            style={{ display: 'block' }}
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="recent-transactions">
                            Recent Transactions
                        </h5>
                        <button type="button" className="close" onClick={onClose} aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="tabs-sets">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        id="purchase-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#purchase"
                                        type="button"
                                        aria-controls="purchase"
                                        aria-selected="true"
                                        role="tab"
                                    >
                                        Purchase
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="payment-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#payment"
                                        type="button"
                                        aria-controls="payment"
                                        aria-selected="false"
                                        role="tab"
                                    >
                                        Payment
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="return-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#return"
                                        type="button"
                                        aria-controls="return"
                                        aria-selected="false"
                                        role="tab"
                                    >
                                        Return
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="purchase" role="tabpanel" aria-labelledby="purchase-tab">
                                    {renderTable(purchaseData, 'purchase')}
                                </div>
                                <div className="tab-pane fade" id="payment" role="tabpanel" aria-labelledby="payment-tab">
                                    {renderTable(paymentData, 'payment')}
                                </div>
                                <div className="tab-pane fade" id="return" role="tabpanel" aria-labelledby="return-tab">
                                    {renderTable(returnData, 'return')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

TransactionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default TransactionModal;